const logout = (key: string) => {
  document.cookie = `${key}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  window.location.href = window.location.pathname;
};

export default logout;
